import Rest from '../../Rest'

export default class LegalEntityFormIncidentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/incident_form_config'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

}
